import { Stack } from 'expo-router';
import { DepositCashFlowProvider } from 'features/moveMoney/providers/DepositCashFlowContextProvider';
import React from 'react';

function MoveMoneyLayout() {
  return (
    <DepositCashFlowProvider>
      <Stack screenOptions={{ headerShown: false }} />
    </DepositCashFlowProvider>
  );
}

export default MoveMoneyLayout;
